export default __webpack_public_path__ + "static/media/mud-pro.30e4a249.jpg";